module.exports = __webpack_public_path__ + "eos-eos-logo.svg?88afb8dbf83299f8a42baa6f78479130";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/eos-eos-logo.svg
// module id = 1109
// module chunks = 2